<template>
  <!-- <van-button v-if="env.DEV" @click="onClose">清理缓存</van-button> -->
  <!-- <van-button v-if="env.DEV" @click="onCopy">这个按钮测试用正式不会出现</van-button> -->
  <router-view />
  <div class="door" @click="onDoor"></div>
</template>
<script lang="ts" setup>
import { wxSend } from "./utils/wx";
import { onBackDoor } from "@/utils/backDoor";

const env = import.meta.env;

const onClose = () => {
  localStorage.clear();
  sessionStorage.clear();
};
const onDoor = () =>
  onBackDoor(() => {
    onCopy();
  });

// 监听键盘事件，当按下 C+S+A+T 组合键时执行 onCopy 方法
document.addEventListener("keydown", (e) => {
  if (e.ctrlKey && e.shiftKey && e.altKey && e.key.toLowerCase() === "t") {
    e.preventDefault();

    onBackDoor(() => {
      onCopy();
    }, 2);
  }
});

const onCopy = () => {
  wxSend(localStorage.getItem("useStore") || "");
};
console.log("useStore:++++++++", localStorage.getItem("useStore"));
</script>

<style lang="less" scoped>
.door {
  position: absolute;
  bottom: 0;
  left: 10px;
  width: 5px;
  height: 5px;
  cursor: default;
  user-select: none;
  font-size: 0;
  opacity: 0;
}
</style>
